export const PWA_SHOW_IN_MS = 5 * 24 * 60 * 60 * 1000;

export const HEADER_OFFSET_PX = 220;

export const STORAGE_KEY = "app-color-scheme";

export const ALLOW_PUSH_NOTIF_SHOW_IN_MS = 2 * 24 * 60 * 60 * 1000;

export const LS_LAST = "push:lastPromptAt";
